import { CanDeactivateFn } from '@angular/router';
import { Observable } from 'rxjs';

/**
 * Implemented by any routed component that must confirm before the user navigates away with
 * unsaved work. The component owns the question — the guard only asks it.
 */
export interface ComponentCanDeactivate {
  canDeactivate(): boolean | Observable<boolean> | Promise<boolean>;
}

/**
 * Leave-confirmation guard. The first of its kind in this workspace, so it is intentionally
 * minimal: it defers entirely to the component, which is where the "is there anything to lose"
 * knowledge lives.
 */
export const pendingChangesGuard: CanDeactivateFn<ComponentCanDeactivate> = (component) => {
  return component?.canDeactivate ? component.canDeactivate() : true;
};
